import { useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Card } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import RightHeaderPage from './rightHeader';

const LocationClassCodePage = () => {
  const navigate = useNavigate();
  const columnDefs = [
    { headerName: 'Coverage Location', field: 'location' },
    { headerName: 'Class Code', field: 'classCode' },
    { headerName: 'Full Time', field: 'fullTime' },
    { headerName: 'Part Time', field: 'partTime' },
    { headerName: 'Payroll', field: 'payroll' },
    {
      headerName: 'Action',
      field: 'action',
      flex: 1,
      cellRendererFramework: (params) => (
        <div className="d-flex gap-2">
          {/* Edit Icon (SVG) */}
          <Button variant="warning" size="sm" onClick={() => handleEdit(params.data)}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.828 0.172a2 2 0 0 1 2.828 2.828L6.707 9.121 5.879 9.949 2 14V13h-1v-2.121l3.707-3.707L9.121 5.879l4.707-4.707a2 2 0 0 1 0-2.828z"
                fill="#fff"
              />
            </svg>
          </Button>

          {/* Delete Icon (SVG) */}
          <Button variant="danger" size="sm" onClick={() => handleDelete(params.data)}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 2L3.293 1.293A1 1 0 0 1 4 0h8a1 1 0 0 1 .707 1.293L12 2H4zm3 1h4v10H7V3zm2 3v5h-1V6h1z"
                fill="#fff"
              />
            </svg>
          </Button>
        </div>
      ),
    },
  ];

  // Handler functions for Edit and Delete actions
  const handleEdit = (data) => {
    console.log('Edit action for:', data);
    // Implement your edit logic here
  };

  const handleDelete = (data) => {
    console.log('Delete action for:', data);
    // Implement your delete logic here
  };

  const rowData = [
    {
      location: 'New York',
      classCode: '10001',
      fullTime: '50',
      partTime: '10',
      payroll: '50000',
      flex: 1,
    },
    {
      location: 'Los Angeles',
      classCode: '90001',
      fullTime: '30',
      partTime: '5',
      payroll: '30000',
      flex: 1,
    },
  ];

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div
            className="main"
            // style={{ marginTop: '2rem' }}
          >
            <div className="pageformBloack">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/LocationPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/PreQualifierQuestionPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Location Class Codes
                              <div className=" quote_buttongroup  ">
                                <Button
                                  variant="outline-next"
                                  size="sm"
                                  className="button-icon"
                                  style={{
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 5v14M5 12h14"
                                      className="add_Svg"
                                      stroke="#7C67AD"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                  Add New
                                </Button>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <div
                                className="ag-theme-balham quote-grid-style"
                                style={{
                                  width: '100%',
                                  border: '1px solid #ddd',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                }}
                              >
                                <AgGridReact
                                  columnDefs={columnDefs}
                                  rowData={rowData}
                                  domLayout="autoHeight"
                                  pagination={true}
                                  paginationPageSize={5}
                                  suppressHorizontalScroll={true} // optional
                                />
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationClassCodePage;
